import { render } from "./UserListPage.vue?vue&type=template&id=2eb9dec1"
import script from "./UserListPage.vue?vue&type=script&lang=js"
export * from "./UserListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__